// extracted by mini-css-extract-plugin
module.exports = {"feedIcon":"FeedTemplateIcon_feedIcon__1AS8V"};